<template>
    <v-card
        class="mx-auto">
          <v-toolbar flat color="secondary" height="50px">
              <v-toolbar-title>PIC Vendor</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" small type="button"><v-icon left>{{icon.add}}</v-icon>Tambah PIC</v-btn>
          </v-toolbar>

          <v-card-text>
              <v-data-table
              :headers="headers"
              :options.sync="options"
              :items="dataList"
              :server-items-length="total_data"
              :loading="data_loading"
              :search="search"
              class="elevation-1"
              dense
              >
              <template v-slot:top>
              <v-toolbar flat color="white">
                <v-dialog>
              <template v-slot:activator="{ on }">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field v-model="search"
                    label="Search"
                    single-line
                    hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
              </v-dialog>
                </v-toolbar>
              </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    {{icon.edit}}
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item)"
                  >
                    {{icon.delete}}
                  </v-icon>
                </template>
                <template v-slot:item.status="{ item }">
                    <v-btn v-if="item.active" class="ma-2" color="success" x-small dark>Active
                    <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                    </v-btn>

                    <v-btn v-else class="ma-2" color="" x-small >Disabled
                    <v-icon dark right>mdi-cancel</v-icon>
                    </v-btn>
                </template>
              </v-data-table> 
          </v-card-text>
      </v-card>
</template>
<script>
    /* eslint-disable */
import rules from "@/plugins/validation_rules.js";
let context;
export default{
    name:"vendor.pic.index",
    data:()=>{
        return{
            icon:{
            add:'mdi-plus',
            edit:'mdi-pencil',
            delete:'mdi-delete'
            },
            search:"",
            total_data: 0,
            options: {
                    itemsPerPage: 10,
                    page:1
                },
            dataList: [],
            data_loading: false,
            headers: [
            { text: 'Nama PIC', value: 'fullname'},
            {text:'Photo', value:'photo'},
            { text: 'Job Title', value: 'job_title', align:'center'},
            { text: 'Email', value: 'email'},
            { text: 'Active', value: 'active'},
            { text: 'Created', value: 'timestamps'},
            { text: 'Actions', value: "action" ,sortable:false},
            ],
        }
    },
}
</script>